import { useEffect } from "react";
import { IMPORTANT_NOTICES } from "../features/notices/importantNotices";
import { markNoticeRead, readNoticeIds } from "../services/importantNoticeState";
import { runAutoDialog } from "../services/autoDialogCoordinator";
import { useAppModal } from "./AppModalProvider";

export function ImportantNoticeGate() {
  const modal = useAppModal();
  useEffect(() => {
    let cancelled = false;
    void readNoticeIds().then(async (ids) => {
      const read = new Set(ids);
      for (const notice of IMPORTANT_NOTICES) {
        if (cancelled || read.has(notice.id)) continue;
        const accepted = await runAutoDialog(`notice:${notice.id}`, () => modal.confirm({ title: notice.title, message: notice.body, confirmLabel: "知道了", cancelLabel: "稍后" }));
        if (accepted && !cancelled) await markNoticeRead(notice.id);
      }
    });
    return () => { cancelled = true; };
  }, [modal.confirm]);
  return null;
}
